import { Component } from "react";
import cookie from "react-cookies";
import {Alert, Button, Col, Input, message, Row, Spin} from "antd";
import {CheckCircleTwoTone} from '@ant-design/icons';
import { connect } from "react-redux";
import {get, post} from "../helper/request";
import {error_manager} from "../helper/error_manager";
import {antdSpinLoaderIcon} from "../utils/const";
import {isTrue} from '../utils/utils'
import {userEvents} from "../const/UserEvents";
import '../asset/style/add_case.css';
import ChangePassword from "../component/settings/manageusers/change.password";
import EnableTotp from "component/settings/manageusers/enable.totp";
import {Divider} from "@mui/material";
import {store} from "../helper/store";
import {changeFirstName, setIsTotpEnabled} from "../redux_actions/login.action";
import {checkAbstractAppPermission, demoModeOn, showMfaAlert} from "../component/utils/abstract_app_maker";

class UserAccount extends Component {
  
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            firstName: "",
            lastName: "",
            email: "",
            lastLogin: null,
            createdOn: null,
            lastPasswordChangedOn: null,
            showChangePasswordModal: false,
            selectedUser: {},
            isFormChanged: false,
            showEnableTotpModal: false,
            totpUri: '',
            qrCode: null,
            isTotpEnabledUserAccount: isTrue(JSON.parse(localStorage.getItem('isTotpEnabled'))),
            isFetching: false,
            isSaving: false,
            recoveryTotpCodes: null,
            demoMode: false
        };
    }

    componentDidMount() {
        this.getUserDetails();
    }

    getUserDetails = async () => {
        this.setState({ isFetching: true });
        try {
            let url = `/api/user/${cookie.load('user_id')}/`;
            const {username} =
                await get(url).then(data => {
                    if (checkAbstractAppPermission(demoModeOn)) {
                        this.setState({demoMode: true})
                    }
                    this.setState({
                        selectedUser: data,
                        username: data.username,
                        firstName: data.first_name,
                        lastName: data.last_name,
                        email: data.email,
                        createdOn: (new Date(data.date_joined)).toLocaleString(),
                        lastLogin: (new Date(data.last_login)).toLocaleString(),
                    });
                    return {username: data.username}
                })
            await Promise.all([
                this.getUserEvents(username)
            ])
        } catch (err) {
            error_manager("Unable to fetch User Details. Contact Admin", err);
        } finally {
            this.setState({ isFetching: false });
        }
    };

    getUserEvents = (username) => {
        const url = encodeURI(`/api/get_user_events/${username}/`);
        return get(url)
            .then(({ events }) => {
                const passwordChanged = events.find(({ type }) => type === userEvents.PASSWORD_UPDATED);
                this.setState({
                    lastPasswordChangedOn: passwordChanged?.timestamp ?
                        (new Date(passwordChanged.timestamp).toLocaleString()) : "-"
                })
            })
            .catch((err) => {
                if (err?.response?.data !== "user doesn't have required permissions") {
                    error_manager("Unable to fetch user events", err);
                }
            });
    };

    handleOpenModal = () => {
        this.setState({ showChangePasswordModal: true });
    };

    handleCloseModal = () => {
        this.setState({ showChangePasswordModal: false });
    };

    handleInputChange = (fieldName, value) => {
        this.setState({
            [fieldName]: value,
            isFormChanged: true,
        });
    };

    saveUserDetails = () => {
        this.setState({isSaving: true});
        const url = "/api/update_user/"
        let data = {
            id: cookie.load("user_id"),
            username: this.state.username,
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            email: this.state.email,
        }
        return post(url, data).then(() => {
            this.setState({isFormChanged: false, isSaving: false});
            store.dispatch(changeFirstName(this.state.firstName))
            cookie.save('first_name', this.state.firstName, {path: '/'});
            message.success("User Details Saved")
        }).catch(err => {
            this.setState({isFormChanged: false, isSaving: false});
            if (err.response.status === 400 && err.response.data) {
                this.getUserDetails()
                message.error(err.response.data, 2.5);
            } else {
                this.getUserDetails()
                message.error("Some error occured. Not able to save changes.", 2.5);
            }
        })
    }

    fetchTOTPDetails = async () => {
        let url = "/api/enable_totp/";
        try {
            const response = await post(url);
            if (response.success) {
                this.setState({
                    totpUri: response.totp_uri,
                    qrCode: response.qrcode_img_base64,
                });
            } else {
                message.error("Failed to fetch TOTP details. Please try again.");
            }
        } catch (error) {
            message.error("An error occurred while fetching TOTP details.");
        }
    };

    handleOpenTotpModal = async () => {
        const isTotpEnabledUserAccount = this.state.isTotpEnabledUserAccount;
        const totpUri = this.state.totpUri;
        if (!isTotpEnabledUserAccount) {
            if (!totpUri) {
                await this.fetchTOTPDetails();
            }
            if (this.state.totpUri) {
                this.setState({
                    showEnableTotpModal: true,
                });
            }
        }
    };

    handleCloseTotpModal = () => {
        this.setState({
            showEnableTotpModal: false,
        });
    };

    enableTotpSuccess = () => {
        localStorage.setItem("isTotpEnabled", JSON.stringify(true));
        this.props.dispatch(setIsTotpEnabled(true));
        this.setState({
            isTotpEnabledUserAccount: true,
        });
    };

    handleGenerateCodes = () => {
        post("/api/generate_totp_recovery_codes/")
            .then((response) => {
                const { recovery_codes: recoveryCodes } = response;       
                this.setState({
                    recoveryTotpCodes: recoveryCodes,
                });
                this.downloadRecoveryCodes(recoveryCodes);
            })
            .catch((error) => {
                message.error("Error fetching recovery codes. Please try again.");
            });
    };

    downloadRecoveryCodes = (codes) => {
        const blob = new Blob([codes.join("\n")], { type: "text/plain" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        let downloadUserName = cookie.load("username");
        if (downloadUserName === undefined) {
            downloadUserName = "";
        } else {
            downloadUserName = "_" + downloadUserName;
        }
        link.download = "morhple-recovery-codes" + downloadUserName + ".txt";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    render() {
        return (
            <div style={{ backgroundColor: "white", padding: "20px" }} className={"full-parent"}>
                <div style={{ fontSize: 30, fontWeight: 400, marginLeft: 50 }}>Account Details</div>
                <Divider color={"#000"} style={{ opacity: "0.2", margin: 5 }} />
                <Spin spinning={this.state.isFetching} indicator={antdSpinLoaderIcon}>
                    <div style={{ display: "flex" }}>
                        <Row>
                            <Col xl={12} xs={24}>
                                <div style={{ padding: 20, flex: 1 }}>
                                    <div className="full-parent">
                                        <Row>
                                            <Col span={23} offset={1}>
                                                <b>Username</b>
                                            </Col>
                                            <Col span={15} offset={1}>
                                                <Input
                                                    placeholder="Username"
                                                    value={this.state.username}
                                                    style={{ color: "black", cursor: "not-allowed" }}
                                                    autoComplete="off"
                                                    disabled
                                                />
                                            </Col>
                                            <Col span={23} offset={1}>
                                                <div style={{ fontSize: 11 }}>This will be your unique login id.</div>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 30 }}>
                                            <Col span={7} offset={1}>
                                                <b>First Name</b>
                                            </Col>
                                            <Col span={7} offset={1}>
                                                <b>Last Name</b>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={7} offset={1}>
                                                <Input
                                                    placeholder="First Name"
                                                    value={this.state.firstName}
                                                    style={{ cursor: "auto" }}
                                                    name="firstName"
                                                    autoComplete="off"
                                                    onChange={(e) => this.handleInputChange("firstName", e.target.value)}
                                                />
                                            </Col>
                                            <Col span={7} offset={1}>
                                                <Input
                                                    placeholder="Last Name"
                                                    value={this.state.lastName}
                                                    style={{ cursor: "auto" }}
                                                    name="lastName"
                                                    autoComplete="off"
                                                    onChange={(e) => this.handleInputChange("lastName", e.target.value)}
                                                />
                                            </Col>
                                            <Col span={23} offset={1}>
                                                <div style={{ fontSize: 11 }}>
                                                    You can edit these fields, then click on save button to save the changes
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 30 }}>
                                            <Col span={23} offset={1}>
                                                <b>Email</b>
                                            </Col>
                                            <Col span={15} offset={1}>
                                                <Input
                                                    placeholder="Email"
                                                    value={this.state.email}
                                                    style={{ cursor: "auto" }}
                                                    autoComplete="off"
                                                    name="email"
                                                    onChange={(e) => this.handleInputChange("email", e.target.value)}
                                                />
                                            </Col>
                                            <Col span={23} offset={1}>
                                                <div style={{ fontSize: 11 }}>
                                                    You can edit and enter a valid email, For example:{" "}
                                                    <span style={{ fontStyle: "italic" }}>user@example.com</span>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row gutter={[0, 24]}>
                                            <Col span={23} offset={1}>
                                                <Button
                                                    onClick={this.saveUserDetails}
                                                    disabled={this.state.demoMode || !this.state.isFormChanged}
                                                    style={
                                                        this.state.isFormChanged
                                                            ? {
                                                                  borderColor: "rgb(112,11,128)",
                                                                  color: "rgb(112,11,128)",
                                                              }
                                                            : { color: "#9a9898" }
                                                    }
                                                >
                                                    Save Changes
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row gutter={[0, 24]}>
                                            <Col span={23} offset={1}>
                                                <div>
                                                    User created on <span style={{ fontWeight: "bold" }}>{this.state.createdOn}</span>
                                                </div>
                                                <div>
                                                    User last logged in on <span style={{ fontWeight: "bold" }}>{this.state.lastLogin}</span>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row gutter={[0, 24]} style={{ marginTop: 100 }}>
                                            <Col span={23} offset={1}>
                                                <Button
                                                    onClick={this.handleOpenModal}
                                                    style={{
                                                        borderColor: "rgb(112,11,128)",
                                                        color: "rgb(112,11,128)",
                                                    }}
                                                    disabled={this.state.demoMode}
                                                >
                                                    Change Password
                                                </Button>
                                                <ChangePassword
                                                    modalVisible={this.state.showChangePasswordModal}
                                                    username={this.state.username}
                                                    selectedUser={this.state.selectedUser}
                                                    closeModal={this.handleCloseModal}
                                                    changeOwnPassword={true}
                                                />
                                            </Col>
                                            <Col span={23} offset={1}>
                                                <div>
                                                    Password last changed on{" "}
                                                    <span style={{ fontWeight: "bold" }}>{this.state.lastPasswordChangedOn}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                            <Col xl={12} xs={24}>
                                <div className={"full-parent"} style={{ padding: 20, flex: 1 }}>
                                    <div className="full-parent">
                                        <div style={{ fontSize: 20, fontWeight: 500, padding: "20px" }}>Multi-Factor Authentication</div>
                                        <Row gutter={[0, 24]} style={{ padding: 20, paddingLeft: 0, paddingTop: 0 }}>
                                            <Col span={23} offset={1}>
                                                <div
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 400,
                                                        padding: 10,
                                                        paddingLeft: 0,
                                                    }}
                                                >
                                                    Benefits of Enabling TOTP
                                                </div>
                                                <div className="password-rules">
                                                    <ul>
                                                        <li className="totp-rules">
                                                            <strong>Enhance Security:</strong> Enable TOTP for an additional layer of account
                                                            protection.
                                                        </li>
                                                        <li className="totp-rules">
                                                            <strong>Protect Passwords:</strong> Safeguard your account, even if your password is
                                                            compromised.
                                                        </li>
                                                        <li className="totp-rules">
                                                            <strong>Phishing Defense:</strong> Reduce the risk of unauthorized access by adding a
                                                            secure verification step.
                                                        </li>
                                                        <li className="totp-rules">
                                                            <strong>Easy Setup:</strong> Scan a QR code using your authenticator app to complete the
                                                            setup.
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div>
                                                    {this.state.isTotpEnabledUserAccount ? (
                                                        <div style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #52c41a', borderRadius: '4px', padding: '6px 8px', width: '100' }}>
                                                        <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '16px', marginRight: '6px' }} />
                                                        <span style={{ fontSize: '16px' }}>TOTP Active</span>
                                                        </div>
                                                    ) : (
                                                        <Button
                                                        onClick={this.handleOpenTotpModal}
                                                        style={ !this.state.isTotpEnabledUserAccount ? { marginTop: '15px', borderColor: "rgb(112,11,128)", color: "rgb(112,11,128)" } : {marginTop: '15px', color: "#9a9898"}}
                                                        disabled={this.state.demoMode || this.state.isTotpEnabledUserAccount}
                                                        >
                                                        Enable TOTP
                                                        </Button>
                                                    )}
                                                </div>
                                                <EnableTotp
                                                    modalVisible={this.state.showEnableTotpModal}
                                                    closeModal={this.handleCloseTotpModal}
                                                    totpUri={this.state.totpUri}
                                                    enableTotpSuccess={this.enableTotpSuccess}
                                                    qrCode={this.state.qrCode}
                                                    isTotpEnabledUserAccount={this.state.isTotpEnabledUserAccount}
                                                />
                                            </Col>
                                        </Row>
                                        <Row gutter={[0, 24]} style={{ padding: 20, paddingLeft: 0, paddingTop: 0 }}>
                                            <Col span={23} offset={1}>
                                                {this.state.isTotpEnabledUserAccount && (
                                                    <div>
                                                        <div
                                                            style={{
                                                                fontSize: 20,
                                                                fontWeight: 400,
                                                                padding: 10,
                                                                paddingLeft: 0,
                                                            }}
                                                        >
                                                            Recovery Code Management for Account Security
                                                        </div>
                                                        <div className="password-rules">
                                                            <ul>
                                                                <li className="totp-rules">
                                                                    <strong>Secure Backup:</strong> Generate recovery TOTP codes as a secure backup to
                                                                    ensure continuous account access.
                                                                </li>
                                                                <li className="totp-rules">
                                                                    <strong>Account Protection:</strong> Safeguard your account by having a secondary
                                                                    means of access if your regular TOTP device is unavailable.
                                                                </li>
                                                                <li className="totp-rules">
                                                                    <strong>MFA Management:</strong> Periodically generate new recovery codes to
                                                                    ensure effective Multi-Factor Authentication (MFA).
                                                                </li>
                                                                <li className="totp-rules">
                                                                    <strong>Emergency Access:</strong> These one-time-use codes are for situations
                                                                    like device loss. Each recovery code can be used only once.
                                                                </li>
                                                                <Alert message="Please note that once new
                                                                    recovery codes are generated, the old ones can no longer be used for
                                                                    authentication." type="warning" />
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.isTotpEnabledUserAccount && (
                                                    <Button
                                                        type="primary"
                                                        ghost
                                                        onClick={this.handleGenerateCodes}
                                                        style={{marginTop: '15px'}}
                                                    >
                                                        Download New Recovery Codes
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => {
	return {
        isTotpEnabled: state.loginAlerts,
    }
};

export default connect(mapStateToProps)(UserAccount);
